export const Plan = {
  free: "free",
  pro: "pro",
  premium: "premium",
  enterprise: "enterprise"
};
